import { Dialog } from '@mui/material';
import React from 'react';
import exclamation from 'Assets/img/ic_exclamation.png';
import exclamation2 from 'Assets/img/ic_exclamation@2x.png';
import exclamation3 from 'Assets/img/ic_exclamation@3x.png';
import success from 'Assets/img/ic_success.png';
import success2 from 'Assets/img/ic_success@2x.png';
import success3 from 'Assets/img/ic_success@3x.png';
import warning from 'Assets/img/ic_warning_red.png';
import warning2 from 'Assets/img/ic_warning_red@2x.png';
import warning3 from 'Assets/img/ic_warning_red@3x.png';
import IntlMessages from 'Util/IntlMessages';

const exImages = [exclamation, exclamation2, exclamation3];
const suImages = [success, success2, success3];
const waImages = [warning, warning2, warning3];

const CommonDialog = ({
  open = false,
  needIntl = true,
  imageType = '',
  isReverse = false,
  isBigPadding = false,
  onClose = null,
  onConfirm = null,
  cancelTextString,
  confirmTextString,
  cancelText,
  confirmText,
  title,
  content,
  contentString,
  child,
  isProceeding,
  confirmTextColor,
}) => {
  const handleClose = () => {
    if (onClose) onClose();
  };
  const handleConfirm = async () => {
    if (onConfirm) await onConfirm();
    if (onClose) onClose();
  };

  const getImages = type => {
    if (type === 'ex') return exImages;
    if (type === 'wa') return waImages;
    return suImages;
  };

  const images = getImages(imageType);
  const cancelTxt = cancelTextString || <IntlMessages id={cancelText ? cancelText : 'button.close'} />;
  const confirmTxt = confirmTextString || <IntlMessages id={confirmText ? confirmText : 'button.confirm'} />;

  return (
    <Dialog className="common-popup-wrapper" open={open} onClose={handleClose} data-field-toggle="true">
      <div className={`common-popup-body ${isBigPadding && 'big-padding'}`} style={{ minWidth: '250px' }}>
        {imageType && <img srcSet={`${images[1]} 2x, ${images[2]} 3x`} src={[images[0]]} alt="img" />}
        {title && <div className={'common-popup-title'}>{needIntl ? <IntlMessages id={title} /> : title}</div>}
        {content || contentString ? <div className={'common-popup-content'}>{contentString || <IntlMessages id={content} />}</div> : null}
        {child}
      </div>
      <div className="common-popup-footer">
        <button
          onClick={() => (isReverse ? handleConfirm() : handleClose())}
          disabled={isReverse && isProceeding}
          style={{ ...(isReverse && imageType === 'wa' && { color: '#f00' }), ...(isReverse && confirmTextColor && { color: confirmTextColor }) }}
        >
          {isReverse ? confirmTxt : cancelTxt}
        </button>
        {onConfirm && (
          <>
            <div style={{ height: '100%', width: '1px', background: '#eee' }} />
            <button
              onClick={() => (isReverse ? handleClose() : handleConfirm())}
              disabled={!isReverse && isProceeding}
              style={{ ...(!isReverse && imageType === 'wa' && { color: '#f00' }), ...(!isReverse && confirmTextColor && { color: confirmTextColor }) }}
            >
              {isReverse ? cancelTxt : confirmTxt}
            </button>
          </>
        )}
      </div>
    </Dialog>
  );
};

export default CommonDialog;
